/*
* Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
*
* Licensed under the Apache License, Version 2.0 (the "License").
* You may not use this file except in compliance with
* the License. A copy of the License is located at
*
*     http://aws.amazon.com/apache2.0/
*
* or in the "license" file accompanying this file.
* This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
* CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions
* and limitations under the License.
*/

<template>
  <div class="container">
    <!-- <authenticator></authenticator> -->
  </div>
</template>

<script>
// COMPONENTS
// import { Authenticator } from "@/components/profile";

export default {
  name: 'Auth',
  components: {
    // authenticator: Authenticator
  },

  data: () => ({
    userAccessToken: '',
    mfa: false,
  }),
  computed: {
    user() {
      return this.$store.state.userStore.user;
    },
    mfaConfig() {
      const that = this;

      return {
        mfaDescription: "My app's mfa description!!",
        mfaTypes: ['TOTP', 'SMS', 'None'],
        cancelHandler() {
          that.toggleAccordion('mfa');
        },
      };
    },
    profilePicAccordion() {
      return {
        'is-closed': !this.profilePic,
        'is-primary': this.profilePic,
        'is-dark': !this.profilePic,
      };
    },
    mfaAccordion() {
      return {
        'is-closed': !this.mfa,
        'is-primary': this.mfa,
        'is-dark': !this.mfa,
      };
    },
  },
  mounted() {
    if (this.user) {
      const { jwtToken } = this.user.signInUserSession.idToken;
      this.userAccessToken = jwtToken;
    }
  },
  methods: {
    toggleAccordion(el) {
      this[el] = !this[el];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/profile/Auth.vue